import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withViewTransitions } from '@angular/router';

import { ENTRA_AUTH_CONFIG } from './core/auth/entra-auth.config';
import { EntraAuthService } from './core/auth/entra-auth.service';
import { entraAuthInterceptor } from './core/auth/entra-auth.interceptor';
import { AnalyticsService } from './core/telemetry/analytics.service';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

declare global {
  interface Window {
    APP_ENV?: string;
    APP_CONFIG?: typeof environment;
  }
}

function initializeEntraAuth(authService: EntraAuthService): () => Promise<void> {
  return () => authService.initialize();
}

function initializeAnalytics(analyticsService: AnalyticsService): () => void {
  return () => analyticsService.initialize();
}

function initializeAppEnvironmentDebug(): () => void {
  return () => {
    window.APP_ENV = environment.production ? 'production' : 'development';
    window.APP_CONFIG = environment;
    console.log(`App initialized for environment: ${window.APP_ENV}`);
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptors([entraAuthInterceptor])),
    {
      provide: ENTRA_AUTH_CONFIG,
      useValue: environment.entraExternalId
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEntraAuth,
      deps: [EntraAuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAnalytics,
      deps: [AnalyticsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppEnvironmentDebug,
      multi: true
    }
  ]
};

